/**
 * Common Js
 * Description : Common javascript functions
*/

/**
 * @method convertPaisaToInr
 * @params (int) paisa
 * @description For convert the price format paisa to inr
*/
function convertPaisaToInr(paisa = 0){
  paisa = Math.round(parseInt(paisa) / 100);
  paisa += '';
  x = paisa.split('.');
  x1 = x[0];
  x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}

/**
 * @method getShopifyProduct
 * @params (string) product_handle
 * @description For fetch the product data based on product id
*/
async function getShopifyProduct(product_handle = false){
  if(!product_handle) return false;
  const shop_url = window.location.protocol + "//" + window.location.host;
  let product = await fetch(`${shop_url}/products/${product_handle}.js`);
  return await product.json()
}